// Get Category Limits
// ---------------------------
window.categories_limit = 5;


(function() {
    $.ajax({
        url: window.location.origin+'/category_limit',
        success: function(response, textStatus, xhr) {
            if(xhr.status === 200) {
                window.categories_limit = parseInt(response);
            }
        },
        complete: function(xhr, textStatus) {
            if( xhr.status !== 200 ) {
                window.categories_limit = 5;
            }
        }
    });
})();

$(document).ready(function() {


    // Country Check
    // ---------------------------------------------
    $('select[name="country"]').change(function(e) {

        var self = $(this),
            _value = self.val(),
            city = $('input[name="city"]');

        if( _value.toLowerCase() != "india" ) {
            $('._state').text('');
            $('input[name="zip_code"], input[name="city"]').val('');
            return;
        }

        $('input[name="zip_code"], input[name="city"]').val('');
    });





    // Get City By Pincode
    // ---------------------
    $('input[name="zip_code"]').blur(function(e) {
        var self = $(this),
            pin = parseInt($.trim(self.val())),
            country = $('select[name="country"]').val().toLowerCase();

        // pincode should be in digits
        if( country == "india" && ( isNaN(pin) || ! (/^[1-9]\d{5}$/).test($.trim(self.val())) ) ) {
            $(this).closest('div.form-group').addClass('has-error');
            window.notify.push('zip code field requires 6 digits numbers ex.(110016)');
            return false;
        }


        // pincode length should be 6 digits for india
        if( pin.toString().length == 6 && country == "india" ) {
            window.loader.start();

            $(this).closest('div.form-group').removeClass('has-error');

            $.ajax({
                url: window.location.origin+'/api/v1/pincode/'+pin,
                dataType: 'json',
                success: function(response, textStatus, xhr) {
                    if(xhr.status === 200) {
                        var r = response.data,
                            city = r.taluk == 'NA' ? r.district_name : r.taluk,
                            state = r.state_name;

                        $('input[name="city"]').closest('div.form-group').removeClass('has-error');

                        $('input[name="city"]').val(city);
                        $('input[name="state"]').val(state);
                        $('._state').text(state);
                    }
                },
                complete: function(xhr, textStatus) {
                    window.loader.stop();
                    if( xhr.status !== 200 ) {
                        var response = xhr.responseJSON;
                        alert(response.message);
                    }
                }
            });
        }
    });





    // Load User Details based on email address
    // ---------------------------------------
    $('input[name="email"]').on('blur', function(e) {
        e.preventDefault();

        var email = $.trim($(this).val()),
            parent = $(this).closest('.form-group'),
            formElement = $(this).closest('form');


        // Skip this on joinForm
        if( formElement.attr('id') == "joinForm" ) {
            return;
        }

        if( ! parent.hasClass('has-error') && email != "" ) {
            window.loader.start();

            // Attach custom url with default request
            var additionalReq = (/\/dealnet/).test(window.location.pathname)
                                    ? window.location.pathname
                                    : '';

            $.ajax({
                url: window.location.origin + '/check_member' + additionalReq,
                data: {email: email},
                success: function(response, textStatus, xhr) {
                    window.loader.stop();
                    if(xhr.status === 200 && response.data != undefined ) {
                        var r = response.data;

                        $('input[name="city"]').prop('readonly', true);
                        if( r.country.toLowerCase() != "india" ) {
                            $('input[name="city"]').prop('readonly', false);
                        }

                        $('input[name="name"]').val(r.name);
                        $('input[name="organization"]').val(r.company);
                        $('select[name="country"]').val(r.country);
                        $('input[name="mobile"]').val(r.mobile);
                        $('input[name="zip_code"]').val(r.zip);
                        $('input[name="city"]').val(r.city);
                        $('input[name="homepage"]').val(r.home);
                        $('textarea[name="address"]').val(r.address);

                    }
                },
                complete: function(xhr, textStatus) {
                    window.loader.stop();

                    if( xhr.status == 403 ) {
                        var response = xhr.responseJSON;
                        window.notify.push(response.message);
                    }
                }
            });
        }
    });



    // Load SubCategories from Main Category
    // --------------------------------------
    $('.category_list li').click(function(e) {
        e.preventDefault();

        var self = $(this),
            catId = self.data('key');

        $('.category_list li').removeClass('active');
        self.addClass('active');

        if( catId != null ) {
            window.loader.start();

            $.ajax({
                url: window.location.origin+'/api/v1/category/'+catId+'/subcategory',
                dataType: 'json',
                success: function(response, textStatus, xhr) {
                    if(xhr.status === 200) {
                        var li = '';
                        $.each(response.data, function(i, data) {
                            li += '<li data-key="'+data.file_name+'"><label class="text-dotted">'+data.cat_name+'</label></li>'
                        });

                        $('.sub_category').html(li);
                    }
                },
                complete: function(xhr, textStatus) {
                    window.loader.stop();
                    if( xhr.status !== 200 ) {
                        var response = xhr.responseJSON;
                        alert(response.message);
                    }
                }
            });
        }
    });




    // Select Sub categories
    // ---------------------------
    $('.sub_category').on('click', 'li', function(e) {
        e.preventDefault();

        var self = $(this),
            catWrapper = '<span class="label label-success animated bounceIn"><span class="text-dotted">{subCatname} <input type="hidden" name="subcats[]" value="{subCatkey}"/></span><a href="javascript:;" data-key="{subCatkey}"><i class="material-icons">clear</i></a></span>';

        if( ! self.hasClass('active') ) {
            self.addClass('active');

            var key = self.data('key'),
                catName = self.text();

            $('.sub_cat_box').removeClass('has-error');

            // Category Should added only once
            if( window.member_categories.indexOf(key) === -1 ) {

                // Check Category Limit
                if( window.member_categories.length >= window.categories_limit ) {
                    window.notify.push('Maximum '+window.categories_limit+' categories for FREE members');
                    self.removeClass('active');
                    return false;
                }

                window.member_categories.push(key);

                $('.sub_category_holder').append(
                    catWrapper.replace(/\{subCatname\}/g, catName)
                            .replace(/\{subCatkey\}/g, key)
                );
            }
        }
    });





    // Remove Sub-categories
    // -----------------------
    $('.sub_category_holder').on('click', 'a', function(e) {
        e.preventDefault();

        var subCat = $(this).data('key'),
            parent = $(this).closest('span.label');

        window.member_categories = window.member_categories.filter(function(item) {
            return item !== subCat;
        });


        if( window.member_categories.length == 0 ) {
            $('.sub_cat_box').addClass('has-error');
        }

        $('.sub_category li[data-key="'+subCat+'"]').removeClass('active');
        parent.remove();
    });
});
